import { fetchData, PaginationParameters, PaginationResponse } from "@request";
import { getQueryParams } from "@request/helpers";

export type Device = {
  id: string;
  name: string;
};

export type DevicesDescriptionForm = PaginationParameters<{
  active?: boolean;
  deleted?: boolean;
}>;

export type AddDeviceForm = {
  name: string;
  url: string;
};

export type UpdateDeviceForm = {
  deviceId: string;
  at_work?: boolean;
  delete?: boolean;
  name?: string;
};

export type DeviceDescription = {
  active: boolean;
  at_work: boolean;
  deleted: boolean;
  app_version: string;
  device_model: string;
  fingerprint: string;
  id: string;
  last_active?: string | null;
  last_active_unix: number;
  name: string;
  charge: number;
  phone_number: string;
  updated_at: string;
  updated_at_unix: number;
  created_at: string;
  created_at_unix: number;
};

export type DevicesDescriptionResponse = PaginationResponse<{
  device_description: DeviceDescription[] | null;
}>;

export type Message = {
  date: string;
  date_unix: number;
  message: string;
  sender: string;
};

export type DeviceMessages = Omit<DeviceDescription, "updated_at"> & {
  message: Message[];
};

export const getDevices = async (userId: string) => {
  try {
    const response = await fetchData<Device[]>({
      url: `api/v1/users/devices/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Devices failed:", error);
    throw error;
  }
};

export const getDevicesDescription = async (
  userId: string,
  data: DevicesDescriptionForm
) => {
  try {
    const queryParams = getQueryParams(data);

    const response = await fetchData<DevicesDescriptionResponse>({
      url: `api/v1/users/description-devices/${userId}?${queryParams}`,
    });

    return response;
  } catch (error) {
    console.error("Devices description failed:", error);
    throw error;
  }
};

export const getDeviceMessages = async (userId: string, deviceId: string) => {
  try {
    const response = await fetchData<DeviceMessages>({
      url: `api/v1/users/devices/${userId}/${deviceId}`,
    });

    return response;
  } catch (error) {
    console.error("Device messages failed:", error);
    throw error;
  }
};

export const addDevice = async (userId: string, data: AddDeviceForm) => {
  try {
    const response = await fetchData<string>({
      method: "POST",
      url: `api/v1/users/add-device/${userId}`,
      data,
    });

    return response;
  } catch (error) {
    console.error("Add device failed:", error);
    throw error;
  }
};

export type CreateQRDeviceResponse = {
  device_id: string;
  qr_code: string;
};

export const createQRDevice = async (userId: string) => {
  try {
    const response = await fetchData<CreateQRDeviceResponse>({
      method: "POST",
      url: `api/v1/users/create-qr-data/${userId}`,
    });

    return response;
  } catch (error) {
    console.error("Create QR device failed:", error);
    throw error;
  }
};

export const updateDevice = async (userId: string, data: UpdateDeviceForm) => {
  try {
    const response = await fetchData<string>({
      method: "PUT",
      url: `api/v1/users/devices/${userId}/${data.deviceId}`,
      data,
    });

    return response;
  } catch (error) {
    console.error("Update device failed:", error);
    throw error;
  }
};
